import React from 'react';
import { Box, Button, makeStyles } from '@material-ui/core';
import styles from './styles';
import accentposLogo from '../../../../../../utils/images/accentpos-logo.png';

const useStyles = makeStyles(styles);

interface LocationInfo {
  logo_image_added?: boolean;
  background_image_added?: boolean;
  ordering_system_primary_color?: string;
  ordering_system_secondary_color?: string;
}

interface StartOrderCoverScreenProps {
  onStart: () => void;
  locationInfo?: LocationInfo;
  location_id?: string;
}

const StartOrderCoverScreen: React.FC<StartOrderCoverScreenProps> = ({ onStart, locationInfo, location_id }) => {
  const classes = useStyles();

  const locationId = location_id || '';

  const logoSrc = locationInfo?.logo_image_added
    ? `${process.env.REACT_APP_AWS_ORDERING_SYSTEM_IMAGES_URL}/${locationId}-logo.jpeg`
    : `${process.env.REACT_APP_AWS_IMAGES_URL}/no-image.jpeg`;

  const backgroundImageUrl = locationInfo?.background_image_added
    ? `${process.env.REACT_APP_AWS_ORDERING_SYSTEM_IMAGES_URL}/${locationId}-background.jpeg`
    : `${process.env.REACT_APP_AWS_ORDERING_SYSTEM_IMAGES_URL}/default-background.jpeg`;

  return (
    <Box className={classes.root} style={{ backgroundImage: `url('${backgroundImageUrl}')` }}>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start" style={{ marginBottom: '30vh' }}>
        {locationInfo?.logo_image_added ? (
          <img src={logoSrc} alt="Logo" className={classes.customLogo} style={{ marginBottom: 56 }} />
        ) : (
          <img src={logoSrc} alt="Logo" className={classes.noLogo} style={{ marginBottom: 56 }} />
        )}
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={onStart}
          className={classes.mainButton}
          style={{
            ...(locationInfo?.ordering_system_primary_color ? { backgroundColor: locationInfo.ordering_system_primary_color } : {}),
            ...(locationInfo?.ordering_system_secondary_color ? { color: locationInfo.ordering_system_secondary_color } : {}),
          }}>
          Start Order
        </Button>
      </Box>
      <Button className={classes.logoButton}>
        <img src={accentposLogo} alt="AccentPOS Logo" className={classes.logoImage} />
      </Button>
    </Box>
  );
};

export default StartOrderCoverScreen;
